<template>
  <v-container fluid>
    <v-row dense>
      <v-col v-for="card in cards" :key="card.title" :cols="card.cols" :sm="card.sm" :md="card.md" :lg="card.lg">
        <v-card outlined>
          <v-img  @click="click_Link(card)" :src="card.src" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            height="220px">
            <v-card-title v-text="card.title" />
          </v-img>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon @click="click_help(card)">$info</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>$heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>$share</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-dialog v-model="defaultDialog" max-width="1200">
        <i-dialog-info :dialog-title="currentTitle" @hide="hideDialog">
          <template v-slot:dialogBody>
            <div v-if="currentId == '1'">
              1 / 레이아웃 샘플 정리
            </div>
            
          </template>
        </i-dialog-info>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import Colors from '@/views/help/Colors.vue'
  import iDialogInfo from '@/components/common/iDialogInfo.vue'

  export default {
    name: 'Help',
    components: {
      Colors,
      'i-dialog-info': iDialogInfo
    },
    data() {
      return {
        defaultDialog: false,
        currentId: '',
        currentTitle: '',
        cards: [
          {
            id: '1',
            title: '레이아웃 샘플',
            src: require(`@/assets/images/help/grid.png`),
            link: 'layoutsample',
            cols: 12,
            md: 6,
            lg: 4
          }

        ],
      }
    },
    methods: {
      showDialog() {
        this.defaultDialog = true
      },
      hideDialog() {
        this.defaultDialog = false
      },
      click_help(params) {
        this.currentTitle = params.title
        this.currentId = params.id
        this.showDialog()
      },
      // 클릭하면 링크타고 감
      click_Link(params) {
        this.currentLink = params.link
        this.$router.push({ path: this.currentLink })
      },

    }
  }
</script>